import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";

function NavSubCategoryList() {
  const token = localStorage.getItem("token");
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentSubCategory, setCurrentSubCategory] = useState({
    id: "",
    name: "",
  });

  const modalStyles = {
    display: "flex",
    position: "fixed",
    zIndex: 1000,
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    justifyContent: "center",
    alignItems: "center",
  };

  const modalContentStyles = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
    width: "400px",
    maxWidth: "90%",
  };

  const inputStyles = {
    margin: "10px 0",
    padding: "8px",
    width: "100%",
    boxSizing: "border-box",
  };

  const getCategories = async () => {
    if (!token) return;
    try {
      const response = await get("UserAuthentication/GetAllCategory", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCategoryData(response.navCategory);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getSubCategoryList = async (categoryId) => {
    if (!token || !categoryId) return;
    try {
      const formdata = { formCategoryId: categoryId };
      const response = await post(
        `UserAuthentication/GetAllNavSubCategory`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSubCategoryData(response);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const handleEdit = async (id) => {
    const formdata = { id: id };
    try {
      const response = await post(
        `UserAuthentication/GetNavSubCategoryById`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCurrentSubCategory(response);
      setIsEditMode(true);
      setModalOpen(true);
    } catch (error) {
      console.error("Error fetching subcategory:", error);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this subcategory?"
    );
    if (confirmDelete) {
      const formdata = { id: id };
      try {
        await post(`UserAuthentication/DeleteNavSubCategory`, formdata, {
          headers: { Authorization: `Bearer ${token}` },
        });
        getSubCategoryList(selectedCategoryId);
      } catch (error) {
        console.error("Error deleting subcategory:", error);
      }
    } else {
      console.log("Deletion canceled.");
    }
  };

  const handleCreate = () => {
    setCurrentSubCategory({ id: "", name: "" });
    setIsEditMode(false);
    setModalOpen(true);
  };

  const handleSave = async () => {
    if (!currentSubCategory.name.trim()) {
      alert("Subcategory name is required.");
      return;
    }

    const saveId = currentSubCategory.id ? currentSubCategory.id : 0;
    const formdata = {
      id: saveId,
      name: currentSubCategory.name,
      formCategoryId: selectedCategoryId,
    };
    try {
      await post(`UserAuthentication/AddUpdateNavSubCategory`, formdata, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModalOpen(false);
      getSubCategoryList(selectedCategoryId);
    } catch (error) {
      console.error("Error saving subcategory:", error);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    if (selectedCategoryId) {
      getSubCategoryList(selectedCategoryId);
    } else {
      setSubCategoryData([]); // Clear subcategory data when no category is selected
    }
  }, [selectedCategoryId]);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      omit: false,
    },
    {
      name: "Sub Category Name",
      selector: (row) => `${row.name}`,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <button
            className="btn btn-outline-primary py-1 px-2 lh-2"
            onClick={() => handleEdit(row.id)}
          >
            Edit
          </button>
          <button
            className="btn btn-outline-danger py-1 px-2 lh-2"
            onClick={() => handleDelete(row.id)}
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <div className="col-md-3">
        <label htmlFor="categorySelect">Select Category:</label>
        <select
          id="categorySelect"
          value={selectedCategoryId}
          className="form-control"
          onChange={(e) => setSelectedCategoryId(e.target.value)}
        >
          <option value="">--Select Category--</option>
          {categoryData.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
      </div>

      <button className="btn btn-outline-primary" onClick={handleCreate}>
        Create Subcategory
      </button>

      {selectedCategoryId ? (
        <DataTable columns={columns} data={subCategoryData} pagination dense />
      ) : (
        <div className="text-center mt-3">
          <p>
            No records found. Please select a category to view subcategories.
          </p>
        </div>
      )}

      {modalOpen && (
        <div className="modal" style={modalStyles}>
          <div className="modal-content" style={modalContentStyles}>
            <h2>{isEditMode ? "Edit Subcategory" : "Create Subcategory"}</h2>
            <div>
              <label>ID:</label>
              <input
                type="text"
                value={currentSubCategory.id}
                readOnly
                style={inputStyles}
              />
            </div>
            <div>
              <label>Name:</label>
              <input
                type="text"
                value={currentSubCategory.name}
                onChange={(e) =>
                  setCurrentSubCategory({
                    ...currentSubCategory,
                    name: e.target.value,
                  })
                }
                style={inputStyles}
              />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={handleSave}
                className="btn btn-outline-success"
                style={{ marginRight: "10px" }}
              >
                Save
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn btn-outline-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default NavSubCategoryList;
